<template>
  <div style="white-space: normal !important;" v-html="resolvedVbzNr"></div>
</template>
<script>
import wsMixin from "@/modules/customerVbzWorksheet/wsMixin";

export default {
  name: 'VbzNrResolverCell',
  mixins: [wsMixin],
  props: {
    column:Object,
    absence:Object,
    isAssignedToDifferentView:Boolean,
  },

  computed: {
    resolvedVbzNr(){
      return this.mx_zueri9VbzNr(this.absence);
    },
  },
};
</script>